__webpack_require__.p = "https://static.age.awaze.com/search-mfe/ad9f885/_next/";